import { ActivityText, TextActivityCard } from "@adsk/alloy-react-activity-log";
import React from "react";
import { ActivityLogCardCommonProps } from "../activityLogTypes";
import { activityTextDefaultStyle } from "./activityTextDefaultStyle";
import { useTranslations } from "@adsk/acc-issues-translations";
import styled from "styled-components";

type IssueSuggestionGeneratedActivityCardProps = {
  commonActivityProps: ActivityLogCardCommonProps;
  suggestion?: {
    input?: {
      generalDescription?: string;
    };
  };
};

export const IssueSuggestionGeneratedActivityCard = ({
  commonActivityProps,
  suggestion,
}: IssueSuggestionGeneratedActivityCardProps) => {
  const { T } = useTranslations();
  const userInputLabel = T.translate("activityLog.issueSuggestionUserInput");
  const userInput =
    suggestion?.input?.generalDescription ||
    T.translate("activityLog.issueSuggestionUserInputUnknown");
  const bodyText = `${userInputLabel}: ${userInput}`;

  const { isAggregated, ...props } = commonActivityProps;

  return isAggregated ? (
    <ActivityText text={bodyText} style={activityTextDefaultStyle} />
  ) : (
    <TextActivityCard
      {...props}
      /* Used by globals.ts to amend UI issues until https://jira.autodesk.com/browse/WPLT-1164 is fixed */
      className="IssuesActivityLog__activity-card"
      title={T.translate("activityLog.titles.issueSuggestionGenerated")}
      text={
        <Texts>
          <ActivityText
            text={T.translate("activityLog.issueSuggestionGenerated")}
            style={activityTextDefaultStyle}
          />
          <ActivityText text={bodyText} style={activityTextDefaultStyle} />
        </Texts>
      }
      data-testid="issue-suggestion-generated-activity-card"
      style={activityTextDefaultStyle}
    />
  );
};

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
